import React from 'react'
import ServiceApi from '../components/ServiceApi'
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Services from "../components/Services";
import Warning from "../components/Warning";
import Banner from "../components/Banner";
const ServicesApiPage = () => {
  return (
    <div>
      <section className="hidden lg:block">
        <Navbar />
      <Warning/>

      </section>
      <section className="block lg:hidden">
        <Sidebar />
      </section>
      {/* <ServiceAgreement /> */}
      <ServiceApi />
      <Footer/>
    </div>
  )
}

export default ServicesApiPage
